import api from './api.service'

export const suggestionImportEventService = {
    list
};

const BASE_URL = '/suggestionImportEvents'

function list(max) {
    return api.get(BASE_URL, {max: max || 1000, sort: 'dateCreated', order: 'desc'})
}
